import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { IActiveUserReportData } from "../../interfaces/analytics";

const useGetActiveUserReport = (filterQuery: string) => {
    const queryFn = async (): Promise<IActiveUserReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/active-user-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['active-user-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetActiveUserReport;